import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AppointmentBulkCreate, AppointmentBulkCreateResult, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useBulkCreateAppointment(): UseMutationResult<
  AxiosResponse<AppointmentBulkCreateResult>,
  AxiosError<ErrorMessage>,
  AppointmentBulkCreate
> {
  const queryClient = useQueryClient();

  const bulkCreateAppointment = (
    payload: AppointmentBulkCreate,
  ): Promise<AxiosResponse<AppointmentBulkCreateResult>> => {
    return client.post('appointments/create-bulk/', payload);
  };

  return useMutation(bulkCreateAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries('appointments');
      queryClient.invalidateQueries('events');
    },
  });
}
